import Link from '@atlaskit/link';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import * as React from 'react';
export default {
  Link,
  SectionMessage,
  SectionMessageAction,
  React
};